export const VENDORS_FILTER_CATEGORIES = 'categories';